import { useMemo } from 'react';
import { LifeArea } from 'shared/types/life-area';
import { GroupByMode, TaskGroupBy } from 'shared/types/sorting-mode';
import { noGroupingId } from 'shared/views/task-filter-list';

export const useLifeAreaCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  lifeArea?: LifeArea,
) =>
  useMemo(() => {
    if (!lifeArea?.id) {
      return {};
    }
    const _groupBy = (
      [GroupByMode.None, GroupByMode.LifeArea].includes(groupBy!)
        ? GroupByMode.Section
        : groupBy ?? GroupByMode.Section
    ) as Exclude<GroupByMode, GroupByMode.None | GroupByMode.LifeArea>;
    if (_groupBy === GroupByMode.Section) {
      const order: Record<string, string[]> = {
        [noGroupingId]: lifeArea.taskSorting ?? [],
      };

      lifeArea.sections?.forEach((section) => {
        order[section.id] = section.tasks;
      });

      return order;
    }

    return lifeArea.customTaskOrder?.[_groupBy] ?? {};
  }, [
    lifeArea?.customTaskOrder,
    lifeArea?.id,
    lifeArea?.taskSorting,
    lifeArea?.sections,
    groupBy,
  ]);
